import React from 'react';
import { Undo2, Redo2 } from 'lucide-react';
import { cn } from '../../lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

const WorkflowUndoRedoButton = ({
  type = 'undo',
  disabled = false,
  onClick,
  shortcut,
  testId,
}) => {
  const Icon = type === 'redo' ? Redo2 : Undo2;
  const label = type === 'redo' ? 'Redo' : 'Undo';

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            data-testid={testId}
            className={cn(
              'flex h-9 w-9 items-center justify-center rounded-lg border bg-white transition-colors',
              disabled
                ? 'cursor-not-allowed border-slate-200 text-slate-300'
                : 'border-slate-200 text-slate-600 hover:border-slate-300 hover:bg-slate-50',
            )}
            aria-label={label}
          >
            <Icon size={16} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-center">
          <div className="font-medium">{label}</div>
          {shortcut ? <div className="text-[10px] text-slate-300">{shortcut}</div> : null}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default WorkflowUndoRedoButton;
